<section class="block-em" *ngIf="data">
    <header class="block-header">
        <h5>
            {{data.EventName}}
            <i *ngIf="data.IsSupervised" class="fi fi-rs-graduation-cap"></i>
        </h5>
        <aside class="align-self-start">
            <button *ngIf="!data.IsSelected" type="button"
                    class="btn btn-outline-primary" (click)="register()"
                    [disabled]="!canBeRegistered">
                {{'said_events_enroll' | translate}}
            </button>

            <button *ngIf="data.IsSelected" type="button"
                    class="btn btn-secondary" (click)="unregister()"
                    [disabled]="!canBeUnregistered">
                {{'said_events_remove' | translate}}
            </button>
        </aside>
    </header>

    <app-alert *ngIf="!data.StudentTestIsPassed && !isAdded && data.IsSupervised" level="info">{{'said_events_test_not_passed' | translate}}</app-alert>
    <app-alert *ngIf="data.GroupIsFull" level="warning">{{'said_events_group_is_full' | translate}}</app-alert>
    <app-alert *ngIf="data.Error" level="danger">{{data.Error}}</app-alert>

    <div class="row">
        <div class="data-value col-lg-8">
            <label>{{'said_events_lblSkills' | translate}}</label>
            <div class="skills">
                <div *ngFor="let sk of data.Skills; let j = index;">
                    <a href="#" (click)="$event.preventDefault(); openSkill(sk)" [title]="'said_events_card' | translate">
                        <input type="hidden" name="skill_id" value="{{sk.Id}}" />
                        <span>
                            {{sk.Name}}, {{sk.Level}}
                        </span>
                    </a>
                </div>
            </div>
        </div>

        <div class="data-value col-lg-4">
            <label>{{'said_events_type' | translate}}</label>
            <div>
                <i class="fi fi-rs-book"></i>
                <span>
                    {{data.EventTypeName}}
                </span>
            </div>
        </div>
    </div>

    <div id="anchor_{{data.EventId}}">
        <div class="row">
            <div class="data-value col-lg-8 rooms">
                <label>{{'said_events_lblAddress' | translate}}</label>
                <div>
                    <div *ngFor="let room of data.Rooms">
                        <i class="fi fi-rs-marker"></i>
                        <span>{{room.Name}}</span>
                    </div>
                </div>
            </div>

            <div class="data-value col-lg-4">
                <label>{{'said_events_lblDateTime' | translate}}</label>
                <div>
                    <i class="fi fi-rs-clock"></i>
                    <span>
                        {{data.EventTimeFrom | date:'short':'':'lv'}} - {{data.EventTimeTo | date:'shortTime':'':'lv'}}
                    </span>
                </div>
            </div>
        </div>

        <hr class="block-sep mb-3 hidden-md-down" />

        <div class="row">
            <div class="data-value col-lg">
                <label>{{'said_events_lblParticipantCount' | translate}}</label>
                <div>
                    <i class="fi fi-rs-user"></i>
                    <span>
                        {{data.ActualStudentCount}}/{{data.MaxStudentCount}}
                    </span>
                </div>
            </div>

            <div class="data-value col-lg">
                <label>{{'said_events_students_count' | translate}}</label>
                <div>
                    <i class="fi-rs-sort-amount-up-alt"></i>
                    <span>
                        {{'said_events_min_students_count' | translate}}
                        {{data.MinStudentCount}}
                        {{'said_events_max_students_count' | translate}}
                        {{data.MaxStudentCount}}
                    </span>
                </div>
            </div>

            <div class="data-value col-lg">
                <label>{{'said_events_application_period' | translate}}</label>
                <div>
                    <i class="fi fi-rs-exchange"></i>
                    <span>
                        {{data.RegistrationOpenDate | appDate}} - {{data.RegistrationCloseDate | appDate}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</section>
